import { Select } from './ui/select';
import { Button } from './ui/button';
import { Filter } from 'lucide-react';

export function SearchFilters({
  categories = [],
  selectedCategory,
  onCategoryChange,
  dateRange,
  onDateRangeChange,
  sortBy,
  onSortChange,
  isExpanded,
  onToggle
}) {
  const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'date', label: 'Date' },
    { value: 'title', label: 'Title' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'day', label: 'Last 24 Hours' },
    { value: 'week', label: 'Last Week' },
    { value: 'month', label: 'Last Month' },
    { value: 'year', label: 'Last Year' }
  ];

  return (
    <div className="w-full">
      <Button
        variant="ghost"
        size="sm"
        onClick={onToggle}
        className="mb-2 text-muted-foreground hover:text-foreground"
      >
        <Filter className="w-4 h-4 mr-2" />
        {isExpanded ? 'Hide Filters' : 'Show Filters'}
      </Button>

      {isExpanded && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-muted/50 rounded-lg">
          <Select
            value={selectedCategory}
            onValueChange={onCategoryChange}
            placeholder="Select Category"
            data-testid="category-select"
          >
            <Select.Trigger className="w-full">
              <Select.Value placeholder="Select Category" />
            </Select.Trigger>
            <Select.Content>
              <Select.Group>
                <Select.Label>Categories</Select.Label>
                {categories.map((category) => (
                  <Select.Item
                    key={category.value}
                    value={category.value}
                  >
                    {category.label}
                  </Select.Item>
                ))}
              </Select.Group>
            </Select.Content>
          </Select>

          <Select
            value={dateRange}
            onValueChange={onDateRangeChange}
            placeholder="Date Range"
          >
            <Select.Trigger className="w-full">
              <Select.Value placeholder="Date Range" />
            </Select.Trigger>
            <Select.Content>
              <Select.Group>
                <Select.Label>Date Range</Select.Label>
                {dateRangeOptions.map((option) => (
                  <Select.Item
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </Select.Item>
                ))}
              </Select.Group>
            </Select.Content>
          </Select>

          <Select
            value={sortBy}
            onValueChange={onSortChange}
            placeholder="Sort By"
          >
            <Select.Trigger className="w-full">
              <Select.Value placeholder="Sort By" />
            </Select.Trigger>
            <Select.Content>
              <Select.Group>
                <Select.Label>Sort By</Select.Label>
                {sortOptions.map((option) => (
                  <Select.Item
                    key={option.value}
                    value={option.value}
                  >
                    {option.label}
                  </Select.Item>
                ))}
              </Select.Group>
            </Select.Content>
          </Select>
        </div>
      )}
    </div>
  );
}
